import { Trans } from '@lingui/react/macro';
import { UserPlus } from 'lucide-react';
import { memo } from 'react';

import { useChatRenderer } from '../../../ChatRendererProvider';
import { Markdown } from '../../../Markdown';
import { Message } from '../../../ui';

type MembershipRegistrationProps = {
  registration: {
    content: string;
    shouldRegister: boolean;
  };
};

export const MembershipRegistration = memo(function MembershipRegistration({
  registration,
}: MembershipRegistrationProps) {
  const { navigate } = useChatRenderer();
  const { content, shouldRegister } = registration;

  return (
    <Message.BubbleGroup>
      <Message.Bubble>
        <Markdown>{content}</Markdown>
        {shouldRegister && (
          <button
            type='button'
            onClick={() => navigate?.('memberRegistration')}
            className='w-full my-3 flex flex-row items-center justify-center gap-2 rounded-lg bg-emerald-500/15 px-3 py-2.5 text-emerald-500 shadow drop-shadow transition-all enabled:hover:scale-105 enabled:hover:opacity-70 enabled:active:scale-100'
          >
            <UserPlus className='size-5' />
            <Trans>Register</Trans>
          </button>
        )}
      </Message.Bubble>
    </Message.BubbleGroup>
  );
});
